<template>
  <el-row>
    <div v-if="initshow" id="initbox" style="min-height: 520px; display: flex; justify-content: center; align-items: center; flex-wrap: wrap">
      <div :span="24">
        <p><el-button type="primary" @click="initBoxShow = true"><i class="fa fa-cloud"></i>初始化专题空间</el-button></p>
        <p><span :span="24" style="display: block!important; color: red ;margin-top: 14px;">空间费用为42元/GB,不足1GB按1GB计算</span></p>
      </div>
      <el-dialog :visible.sync="initBoxShow">
        <el-form :model="addData" name="initForm" ref="initForm">
          <el-form-item label="FTP用户名" prop="user" :rules="{required: true, message: '有户名不能为空', trigger: 'blur'}">
            <el-input v-model="addData.user" placeholder="请输入FTP用户名"></el-input>
          </el-form-item>
          <el-form-item label="FTP密码" prop="passwd" :rules="{required: true, message: '密码不能为空', trigger: 'blur'}">
            <el-input type="password" v-model="addData.passwd" placeholder="请输入FTP密码"></el-input>
          </el-form-item>
          <el-form-item style="text-align: right;">
            <el-button type="success" @click="handleFtp('initForm')"><i class="fa fa-plus-circle"></i>申请专题空间</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
    <div v-if="operatorshow" id="specials">
      <div id="breadcrumb" style="display: block;">
        <el-breadcrumb separator="/" class="admincrumb">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>营销</el-breadcrumb-item>
          <el-breadcrumb-item>专题管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-tabs type="card">
        <el-tab-pane>
          <span slot="label"><i class="el-icon-date"></i>独立专题</span>
          <div id="toolbar" style="display: block; text-align: right;">
            <el-form class="form-inline">
              <el-form-item>
                <el-button-group>
                  <el-button type="primary" @click="editFtpShow = true"><i class="fa fa-cogs" style="font-weight: bolder; margin-right: 6px;"></i>修改FTP帐户密码</el-button>
                </el-button-group>
              </el-form-item>
            </el-form>
            <el-dialog :visible.sync="editFtpShow">
              <el-form :model="editFtpData" name="editFtpForm" ref="editFtpForm">
                <el-form-item label="新密码" prop="passwd" :rules="{required: true, message: '密码不能为空', trigger: 'blur'}">
                  <el-input type="passwd" v-model="editFtpData.passwd" placeholder="请输入密码"></el-input>
                </el-form-item>
                <el-form-item style="text-align: right;">
                  <el-button type="success" @click="updateFtpPasswd('editFtpForm')"><i class="fa fa-edit"></i>修改FTP密码</el-button>
                </el-form-item>
              </el-form>
            </el-dialog>
            <div><i class="fa fa-bell"></i>FTP服务器地址:ftp.bigevy.com</div>
          </div>
          <div id="dircrum">
            <ul style="list-style: none; display: flex; flex-wrap: wrap; justify-content: flex-start; padding: 0!important; margin-bottom: 32px;">
              <li><a @click="loadDir('')"><i class="fa fa-home"></i>根目录</a></li>
              <li style="margin-left: 8px;"><a v-clipboard:copy="currDir.uri" v-clipboard:success="copySuccess"  v-clipboard:error="copyError" style="color: black;"><i class="fa fa-copy" style="font-size: 16px; margin-right: 3px!important;"></i>复制专题地址</a></li>
            </ul>
          </div>
          <el-row :gutter="12" id="speccontant" style="display: flex; flex-wrap: wrap; justify-content: flex-start; align-items: stretch;">
            <el-col v-for="fold in currDir.dirs" :span="2" :key="fold" style="text-align: center!important; margin-bottom: 22px;"><a type="button" @dblclick="loadDir(currDir.path + '/' + fold)"><div class="fa fa-folder" style="font-size: 56px; color: #E6A23C; display: block;"></div>{{ fold }}</a></el-col>
            <el-col v-for="file in currDir.files" :span="2" :key="file" style="text-align: center!important; margin-bottom: 22px;"><div class="fa fa-file-text" style="font-size: 56px; color: #909399; display: block;"></div>{{ file }}</el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="嵌入式专题">
          <div id="toolbarspec" style="display: block; text-align: right;">
            <el-form :inline="true" :model="sData" name="squery" ref="squery" class="form-inline">
              <el-form-item label="搜索条件">
                <el-input v-model="sData.specName" placeholder="请输入搜索关键词"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button-group>
                  <el-button type="primary"><i class="el-icon-search" style="font-weight: bolder; margin-right: 6px;"></i>专题搜索</el-button>
                  <el-button type="primary" @click="showEmbedSpecBox = true"><i class="fa fa-plus" style="font-weight: bolder; margin-right: 6px;"></i>新增专题</el-button>
                </el-button-group>
              </el-form-item>
            </el-form>
            <el-dialog :visible.sync="showEmbedSpecBox">
              <el-form :model="newEmbedSpec" name="newEmbedSpecForm" ref="newEmbedSpecFtpForm">
                <el-form-item label="专题名称" prop="title" :rules="{required: true, message: '专题名称不能为空', trigger: 'blur'}">
                  <el-input v-model="newEmbedSpec.title" placeholder="请输入专题名称"></el-input>
                </el-form-item>
                <el-form-item label="URI KEY" prop="urikey" :rules="{required: true, message: 'URI KEY名称不能为空', trigger: 'blur'}">
                  <el-input type="passwd" v-model="newEmbedSpec.urikey" placeholder="请输入URI KEY"></el-input>
                </el-form-item>
                <el-form-item label="专题关键词" prop="keywords" :rules="{required: true, message: '专题关键语不能为空', trigger: 'blur'}">
                  <el-input v-model="newEmbedSpec.keywords" placeholder="请输入专题关键语"></el-input>
                </el-form-item>
                <el-form-item label="专题描述" prop="desc" :rules="{required: true, message: '专题描述不能为空', trigger: 'blur'}">
                  <el-input type="textarea" :rows="3" v-model="newEmbedSpec.desc" placeholder="请输入专题描述"></el-input>
                </el-form-item>
                <el-form-item label="专题内容" prop="content" :rules="{required: true, message: '专题内容不能为空', trigger: 'blur'}">
                  <el-input type="textarea" :rows="10" v-model="newEmbedSpec.content" placeholder="请输入专题内容"></el-input>
                </el-form-item>
                <el-form-item style="text-align: right;">
                  <el-button type="success" @click="handleEmbedSpec('newEmbedSpecFtpForm')"><i class="fa fa-hand-grab-o"></i>提交新专题</el-button>
                </el-form-item>
              </el-form>
            </el-dialog>
          </div>
          <el-row>
            <el-table v-loading="pageloading" element-loading-text="拼命加载中..." element-loading-spinner="el-icon-loading" :data="specList" stripe>
              <el-table-column prop="ID" label="ID"></el-table-column>
              <el-table-column prop="title" label="专题标题"></el-table-column>
              <el-table-column prop="keywords" label="专题关键词"></el-table-column>
              <el-table-column prop="desc" label="专题描述"></el-table-column>
              <el-table-column prop="urikey" label="合计"></el-table-column>
              <el-table-column prop="state" label="专题状态">
                <template slot-scope="scop">
                  <span v-if="scop.row.state">可防问</span>
                  <span v-else>禁止访问</span>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="250">
                <template slot-scope="scop">
                  <el-button-group>
                    <el-button type="text" style="margin-right: 8px;" @click="mkEdit(scop.row)">编辑</el-button>
                    <el-button v-if="scop.row.state" type="text" @click="exEmbedState(scop.row.ID)">禁用</el-button>
                    <el-button v-else type="text" @click="exEmbedState(scop.row.ID)" style="margin-right: 8px;">启用</el-button>
                    <el-button type="text" v-clipboard:copy="scop.row.uri" v-clipboard:success="copySuccess"  v-clipboard:error="copyError">复制专题地址</el-button>
                  </el-button-group>
                </template>
              </el-table-column>
            </el-table>
            <el-dialog :visible.sync="showEmbedSpecUpdateBox">
              <el-form :model="currEdit" name="updateEmbedSpecForm" ref="updateEmbedSpecForm">
                <el-form-item label="专题名称" prop="title" :rules="{required: true, message: '专题名称不能为空', trigger: 'blur'}">
                  <el-input v-model="currEdit.title" placeholder="请输入专题名称"></el-input>
                </el-form-item>
                <el-form-item label="URI KEY" prop="urikey" :rules="{required: true, message: 'URI KEY名称不能为空', trigger: 'blur'}">
                  <el-input type="passwd" v-model="currEdit.urikey" placeholder="请输入URI KEY"></el-input>
                </el-form-item>
                <el-form-item label="专题关键词" prop="keywords" :rules="{required: true, message: '专题关键语不能为空', trigger: 'blur'}">
                  <el-input v-model="currEdit.keywords" placeholder="请输入专题关键语"></el-input>
                </el-form-item>
                <el-form-item label="专题描述" prop="desc" :rules="{required: true, message: '专题描述不能为空', trigger: 'blur'}">
                  <el-input type="textarea" :rows="3" v-model="currEdit.desc" placeholder="请输入专题描述"></el-input>
                </el-form-item>
                <el-form-item label="专题内容" prop="content" :rules="{required: true, message: '专题内容不能为空', trigger: 'blur'}">
                  <el-input type="textarea" :rows="10" v-model="currEdit.content" placeholder="请输入专题内容"></el-input>
                </el-form-item>
                <el-form-item style="text-align: right;">
                  <el-button type="success" @click="UpdateEmbedSpec('updateEmbedSpecForm')"><i class="fa fa-refresh"></i>更新专题</el-button>
                </el-form-item>
              </el-form>
            </el-dialog>
          </el-row>
          <el-row>
            <el-pagination
              @current-change="loadSpecial"
              :current-page="currPage.page"
              :page-sizes="[15]"
              :page-size="15"
              layout="total, sizes, prev, pager, next, jumper"
              :total="currPage.total">
            </el-pagination>
          </el-row>
        </el-tab-pane>
      </el-tabs>
      </div>
  </el-row>
</template>

<script>
export default {
  name: 'Special',
  data () {
    return {
      sData: {},
      isInited: '',
      initshow: false,
      operatorshow: false,
      initBoxShow: false,
      addData: {},
      editFtpShow: false,
      editFtpData: {},
      currDir: {},
      newEmbedSpec: {},
      showEmbedSpecBox: false,
      currPage: {page: 1, 'total': 0},
      specList: [],
      pageloading: false,
      showEmbedSpecUpdateBox: false,
      currEdit: {}
    }
  },
  beforeCreate () {
    var that = this
    var para = {}
    para.method = 'shop.shopftpcheck'
    that.$http.post(that.$apiurl, para).then(function (ret) {
      if (ret.body.data.code === 200) {
        that.operatorshow = true
      } else {
        that.initshow = true
      }
    })
  },
  mounted () {
    this.loadDir('')
    this.loadSpecial(1)
  },
  methods: {
    loadSpecial: function (page) {
      var that = this
      this.$set(that.currPage, 'page', page)
      var para = {}
      para.method = 'shop.embedSpecPage'
      para.page = page
      para.num = 15
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.$set(that.currPage, 'total', ret.body.data.count)
        that.specList = ret.body.data.data
      })
    },
    mkEdit: function (row) {
      this.showEmbedSpecUpdateBox = true
      this.currEdit = row
    },
    hasloaded: function () {
      this.load.close()
      this.load = ''
    },
    fullLoad () {
      this.load = this.$loading({
        lock: true,
        text: '请求处理中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    handleFtp: function (formname) {
      var that = this
      that.$refs[formname].validate(valid => {
        if (valid) {
          var para = that.addData
          para.method = 'shop.pageftpinit'
          that.fullLoad()
          that.$http.post(that.$apiurl, para).then(function (ret) {
            that.hasloaded()
            if (ret.body.data.code === 200) {
              this.$message.success('初始化空间成功!')
              that.operatorshow = true
              that.initshow = false
            } else if (ret.body.data.code === 202) {
              this.$alert('用户已经存在，请更换用户名!')
            } else {
              this.$alert('初始化专题空间失败，请稍后重试!')
            }
          })
        }
      })
    },
    updateFtpPasswd: function (formname) {
      var that = this
      that.$refs[formname].validate(valid => {
        if (valid) {
          var para = that.editFtpData
          para.method = 'shop.newshopftppasswd'
          that.fullLoad()
          that.$http.post(that.$apiurl, para).then(function (ret) {
            that.hasloaded()
            if (ret.body.data.code === 200) {
              this.$message.success('密码修改在功!')
              that.loadCoupon(1)
            } else {
              this.$alert('密码修改失败，请稍后重试!')
            }
          })
        }
      })
    },
    loadDir: function (curr) {
      var that = this
      var para = {}
      para.method = 'shop.currftpdir'
      para.path = curr
      that.fullLoad()
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.hasloaded()
        that.currDir = ret.body.data
      })
    },
    handleEmbedSpec: function (formname) {
      var that = this
      that.$refs[formname].validate(valid => {
        if (valid) {
          var para = that.newEmbedSpec
          para.method = 'shop.addembedspec'
          that.fullLoad()
          that.$http.post(that.$apiurl, para).then(function (ret) {
            that.hasloaded()
            if (ret.body.data.code === 200) {
              that.$message.success('新专题提交成功!')
              that.loadSpecial(1)
            } else {
              that.$alert('新专题提交失败，请稍后重试!')
            }
          })
        }
      })
    },
    exEmbedState: function (sid) {
      var that = this
      var para = {}
      para.method = 'shop.embedState'
      para.sid = sid
      that.fullLoad()
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.hasloaded()
        if (ret.body.data.code === 200) {
          that.$message.success('专题状态修改成功!')
          that.loadSpecial(that.currPage.page)
        } else {
          that.$alert('专题状态修改失败，请稍后重试!')
        }
      })
    },
    UpdateEmbedSpec: function (formname) {
      var that = this
      that.$refs[formname].validate(valid => {
        if (valid) {
          var para = that.currEdit
          para.sid = that.currEdit.ID
          para.method = 'shop.embedSpecUpdate'
          that.fullLoad()
          that.$http.post(that.$apiurl, para).then(function (ret) {
            that.hasloaded()
            if (ret.body.data.code === 200) {
              that.$message.success('专题修改成功!')
              that.loadSpecial(that.currPage.page)
            } else {
              that.$alert('专题修改失败，请稍后重试!')
            }
          })
        }
      })
    },
    copySuccess: function (e) {
      this.$message.success('复制成功!')
    },
    copyError: function (e) {
      this.$message.success('未能成功复制!')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/market/Special.vue